import { useSuspenseQuery } from '@apollo/client/react'
import {
  CreateChatWorkspaceDocument,
  DeleteChatWorkspaceDocument,
  GetChatTaskReactionByWorkspaceDocument,
  GetChatWorkspaceDocument,
  GetChatWorkspaceTasksDocument,
  LinkTaskToWorkspaceDocument,
  ListChatWorkspacesDocument,
  UpdateChatTaskReactionDocument,
  UpdateChatWorkspaceDocument,
} from './generated/graphql'
import {
  createFetchQueryHelper,
  createMutationHelper,
  createQueryHook,
  modifyQueryHook,
} from './utils'

export const useGetChatWorkspace = modifyQueryHook(
  createQueryHook(GetChatWorkspaceDocument),
  {
    transform: (id: string) => ({ id }),
    reduce: r => r?.chatWorkspace,
  },
)

export function useSuspenseGetChatWorkspace(id: string) {
  const { data, ...rest } = useSuspenseQuery(GetChatWorkspaceDocument, {
    variables: { id },
    context: { refetchOnFocus: false },
  })
  return { data: data?.chatWorkspace, ...rest }
}

export const useListChatWorkspaces = modifyQueryHook(
  createQueryHook(ListChatWorkspacesDocument),
  {
    reduce: r => r?.chatWorkspaces,
  },
)

export const useGetChatWorkspaceTasks = modifyQueryHook(
  createQueryHook(GetChatWorkspaceTasksDocument),
  {
    transform: (workspaceId: string) => ({ workspaceId }),
    reduce: r => r?.chatWorkspaceTasks,
  },
)

export const fetchGetChatWorkspaceTasks = createFetchQueryHelper(
  GetChatWorkspaceTasksDocument,
)

export const useGetChatTaskReactionByWorkspace = modifyQueryHook(
  createQueryHook(GetChatTaskReactionByWorkspaceDocument),
  {
    transform: (workspaceId: string) => ({ workspaceId }),
    reduce: r => r?.chatTaskReactionByWorkspace,
  },
)

export function useSuspenseGetChatTaskReactionByWorkspace(workspaceId: string) {
  const { data, ...rest } = useSuspenseQuery(
    GetChatTaskReactionByWorkspaceDocument,
    {
      variables: { workspaceId },
      context: { refetchOnFocus: false },
    },
  )
  return { data: data?.chatTaskReactionByWorkspace, ...rest }
}

export const [useCreateChatWorkspace, executeCreateChatWorkspace] =
  createMutationHelper(CreateChatWorkspaceDocument)

export const [useDeleteChatWorkspace, executeDeleteChatWorkspace] =
  createMutationHelper(DeleteChatWorkspaceDocument)

export const [useUpdateChatWorkspace, executeUpdateChatWorkspace] =
  createMutationHelper(UpdateChatWorkspaceDocument)

export const [useUpdateChatTaskReaction, executeUpdateChatTaskReaction] =
  createMutationHelper(UpdateChatTaskReactionDocument)

export const [useLinkTaskToWorkspace, executeLinkTaskToWorkspace] =
  createMutationHelper(LinkTaskToWorkspaceDocument)
